import e, { removeClassStyleAttrs as t, returnFirstEl as n, warnIfUnmounted as r } from "../../common/utils/index.js";
import { t as i } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { DialtoneLocalization as a } from "../../localization/index.js";
import o from "../button/button.js";
import s from "../dropdown/dropdown.js";
import { CALLBAR_BUTTON_VALID_WIDTH_SIZE as c } from "../callbar-button/callbar-button-constants.js";
import l from "../callbar-button/callbar-button.js";
import { createBlock as u, createCommentVNode as d, createElementBlock as f, createSlots as p, createVNode as m, mergeProps as h, normalizeClass as g, normalizeStyle as _, openBlock as v, renderSlot as y, resolveComponent as b, withCtx as x } from "vue";
import { DtIconChevronUp as S } from "@dialpad/dialtone-icons/vue";
//#region recipes/buttons/callbar_button_with_dropdown/callbar_button_with_dropdown.vue
var C = {
	name: "DtRecipeCallbarButtonWithDropdown",
	components: {
		DtRecipeCallbarButton: l,
		DtDropdown: s,
		DtButton: o,
		DtIconChevronUp: S
	},
	inheritAttrs: !1,
	props: {
		id: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		ariaLabel: {
			type: String,
			default: null,
			validator: (e) => e || (void 0).$slots.default
		},
		placement: {
			type: String,
			default: "top"
		},
		fallbackPlacements: {
			type: Array,
			default: () => ["auto"]
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		forceShowArrow: {
			type: Boolean,
			default: !1
		},
		active: {
			type: Boolean,
			default: !1
		},
		danger: {
			type: Boolean,
			default: !1
		},
		onClick: {
			type: Function,
			default: null
		},
		buttonClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		textClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		buttonWidthSize: {
			type: String,
			default: "xl",
			validator: (e) => c.includes(e)
		},
		invertedTooltip: {
			type: Boolean,
			default: !1
		},
		showTooltip: {
			type: Boolean,
			default: null
		},
		tooltipText: {
			type: String,
			default: void 0
		},
		tooltipDelay: {
			type: Boolean,
			default: void 0
		}
	},
	emits: [
		"arrow-click",
		"click",
		"opened"
	],
	data() {
		return {
			open: !1,
			i18n: new a()
		};
	},
	computed: {
		showArrowButton() {
			return this.forceShowArrow || !this.disabled;
		},
		isCompactMode() {
			return this.buttonWidthSize === "sm" || this.buttonWidthSize === "md";
		},
		arrowButtonLabel() {
			return this.i18n.$t("DIALTONE_CALLBAR_BUTTON_WITH_DROPDOWN_ARROW_BUTTON_ARIA_LABEL");
		}
	},
	mounted() {
		r(n(this.$el), this.$options.name);
	},
	methods: {
		removeClassStyleAttrs: t,
		arrowClick(e) {
			return this.$emit("arrow-click", e), this.toggleOpen();
		},
		toggleOpen() {
			return this.open = !this.open;
		},
		syncOpenState() {
			this.open = this.openDropdown;
		},
		buttonClick(e) {
			this.$props.onClick ? this.$emit("click", e) : this.arrowClick(e);
		},
		onModalIsOpened(e) {
			this.open = e, this.$emit("opened", e);
		}
	}
};
function w(e, t, n, r, i, a) {
	let o = b("dt-recipe-callbar-button"), s = b("dt-icon-chevron-up"), c = b("dt-button"), l = b("dt-dropdown");
	return v(), f("div", {
		class: g(["dt-recipe--callbar-button-with-dropdown", e.$attrs.class]),
		style: _(e.$attrs.style)
	}, [m(o, {
		active: n.active,
		"aria-label": n.ariaLabel,
		"button-class": n.buttonClass,
		"button-width-size": n.buttonWidthSize,
		danger: n.danger,
		disabled: n.disabled,
		"inverted-tooltip": n.invertedTooltip,
		"show-tooltip": n.showTooltip,
		"text-class": n.textClass,
		"tooltip-delay": n.tooltipDelay,
		"tooltip-text": n.tooltipText,
		class: "dt-recipe--callbar-button-with-dropdown--main-button",
		onClick: a.buttonClick
	}, p({
		tooltip: x(() => [y(e.$slots, "tooltip")]),
		default: x(() => [y(e.$slots, "default")]),
		_: 2
	}, [e.$slots.blockStartIcon ? {
		name: "blockStartIcon",
		fn: x(() => [y(e.$slots, "blockStartIcon")]),
		key: "0"
	} : void 0, e.$slots.icon ? {
		name: "icon",
		fn: x(() => [y(e.$slots, "icon")]),
		key: "1"
	} : void 0]), 1032, [
		"active",
		"aria-label",
		"button-class",
		"button-width-size",
		"danger",
		"disabled",
		"inverted-tooltip",
		"show-tooltip",
		"text-class",
		"tooltip-delay",
		"tooltip-text",
		"onClick"
	]), a.showArrowButton ? (v(), u(l, h({
		key: 0,
		id: n.id,
		"fallback-placements": n.fallbackPlacements,
		open: i.open,
		modal: !1,
		placement: n.placement,
		class: "dt-recipe--callbar-button-with-dropdown--dropdown-wrapper",
		padding: "none"
	}, a.removeClassStyleAttrs(e.$attrs), { onOpened: a.onModalIsOpened }), {
		anchor: x(() => [m(c, {
			active: i.open,
			class: g(["dt-recipe--callbar-button-with-dropdown--arrow", { "dt-recipe--callbar-button-with-dropdown--arrow--large": !a.isCompactMode }]),
			circle: !0,
			importance: "clear",
			size: 400,
			"aria-label": a.arrowButtonLabel,
			title: a.arrowButtonLabel,
			width: "2rem",
			onClick: a.arrowClick
		}, {
			startIcon: x(() => [m(s, {
				class: "dt-recipe--callbar-button-with-dropdown--arrow__icon",
				size: "200"
			})]),
			_: 1
		}, 8, [
			"active",
			"class",
			"aria-label",
			"title",
			"onClick"
		])]),
		list: x(({ close: t }) => [y(e.$slots, "list", { close: t })]),
		_: 3
	}, 16, [
		"id",
		"fallback-placements",
		"open",
		"placement",
		"onOpened"
	])) : d("", !0)], 6);
}
var T = /* @__PURE__ */ i(C, [["render", w]]);
//#endregion
export { T as default };

//# sourceMappingURL=callbar-button-with-dropdown.js.map